import React, {useContext} from "react";
// @ts-ignore
import classNames from 'classnames';
// @ts-ignore
import '../RankingsAndLevelsComponent/RankingsAndLevels.css'
import Colors from "../../assets/colors/Colors";
import Images from "../../assets/images/Images";
import GraphNavbar from "./Components/GraphNavbar";
import LifeNavabar from "./Components/LifeNavbar";
import TierNavbar from "./Components/TierNavbar";
import BarChart from "../d3/BarChart";
import PageSelector from "./Components/PageSelector";
import styled from "styled-components";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import {SkeletonWorldCircle} from "../SkeletonLoader/SkeletonLoaders";
import '../AnimationWrapper/WrapperAnimations.css'
import withLoadingAnimation from "../AnimationWrapper/AnimationWrapper";
import Constants from "../../data/Constants";
import { RankingsAndLevelsContext } from "../../contexts/RankingsAndLevelsContext";


interface TierGraphicsProps {
    isLife: boolean,
    yearCode: string,
    pageSelected: number,
    handlePageChange: (pageMovement: number) => void,
    maxPage: number,
    displayDataCountries: any,
    maxGip: number,
    firstPageLength: number
}


const TierGraphicsContainerDiv = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1% 2%;
  position: relative;

  &:after {
    content: '';
    background-attachment: fixed;
    background-image: url(${(props: { isLife: boolean }) => props.isLife ? Images.mapBackgroundLife : Images.mapBackgroundNoLife});
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 0.3;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
  }

  &:before {
    content: '';
    background-color: ${(props: { isLife: boolean }) => props.isLife ? Colors.backgroundGray : Colors.backgroundWhite};
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -2;
  }

  & .basic-container {
    flex: 0 1 auto;

    & svg {
      height: 100%;
    }
  }
`;

const TierGraphicsComponent: React.FC<TierGraphicsProps> = ({isLife, yearCode, pageSelected, handlePageChange, maxGip, maxPage, displayDataCountries, firstPageLength}) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);

    return (
        <TierGraphicsContainerDiv isLife={isLife}>
            <TierNavbar backRoute={`${Constants.routes.rankings}/${yearCode}/tiers`}/>
            <LifeNavabar/>
            <GraphNavbar/>
            <PageSelector pageSelected={pageSelected} handlePageChange={handlePageChange} maxPage={maxPage} isLife={isLife}/>
            <div
                className={classNames('ranking-container', 'basic-container')}
                style={{
                    justifyContent: 'center',
                    height: '60vh',
                    position: 'relative',
                    pointerEvents: 'none'
                }}
            >
                {
                    withLoadingAnimation(
                        <BarChart countries={displayDataCountries} maxGip={maxGip} firstPageLength={firstPageLength} isLife={ isLife }/>,
                        <SkeletonWorldCircle customStyle={{height: '80%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}/>,
                        allDataLoaded
                    )
                }
            </div>
        </TierGraphicsContainerDiv>
    )
};

export default TierGraphicsComponent;
